/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

const ES = {
  LOADING: 'Cargando ...',
  SAVING: 'Grabando ...',
  SAVE_COMPLETE: 'Grabado completo',
  ZOOM_IN_ERROR: 'El zoom es muy alto.',
  ZOOM_ERROR: 'No es posible aplicar mas zoom.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: 'No ha sido posible crear un nuevo tópico. Sólo un tópico debe ser seleccionado.',
  ONE_TOPIC_MUST_BE_SELECTED: 'No ha sido posible crear un nuevo tópico. Al menos un tópico debe ser seleccionado.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: 'Tópicos hijos no pueden ser colapsados. Sólo un tópico debe ser seleccionado.',
  SAVE_COULD_NOT_BE_COMPLETED: 'Grabación no pudo ser completada. Intentelo mas tarde.',
  MAIN_TOPIC: 'Tópico Principal',
  SUB_TOPIC: 'Tópico Secundario',
  ISOLATED_TOPIC: 'Tópico Aislado',
  CENTRAL_TOPIC: 'Tópico Central',
  ENTITIES_COULD_NOT_BE_DELETED: 'El tópico o la relación no pudo ser borrada. Debe selecionar al menos una.',
  CLIPBOARD_IS_EMPTY: 'Nada que copiar. Clipboard está vacio.',
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: 'El tópico central no puede ser borrado.',
  RELATIONSHIP_COULD_NOT_BE_CREATED: 'La relación no pudo ser creada. Una relación padre debe ser seleccionada primero.',
  SESSION_EXPIRED: 'Su session ha expirado. Por favor, ingrese nuevamente.',
  CENTRAL_TOPIC_CONNECTION_STYLE_CAN_NOT_BE_CHANGED: 'El estilo de conexión no se puede cambiar para el tópico central.',
  CENTRAL_TOPIC_STYLE_CAN_NOT_BE_CHANGED: 'Tópico central no se puede cambiar al estilo de línea.',
  TAB_TO_CREATE_CHILD: 'para crear hijo',
  ENTER_TO_CREATE_SIBLING: 'para crear hermano',
  PLUS_TOOLTIP_CREATE_CHILD: 'Crear tópico hijo',
  PLUS_TOOLTIP_CREATE_SIBLING: 'Crear tópico hermano',
};

export default ES;
